import useCombinedRefs from 'hooks/use-combined-refs';
import Drawer, { DrawerRefType } from 'mantine-components/widget/drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import UniskaiPivotContent from './uniskai-pivot-content';

interface UniskaiPivotTableDrawerProps {}

const UniskaiPivotTableDrawer = React.forwardRef<
  DrawerRefType,
  UniskaiPivotTableDrawerProps
>((props, ref) => {
  const { t } = useTranslation();

  const innerRef = React.useRef<DrawerRefType>(null);
  const combinedRef = useCombinedRefs(innerRef, ref);

  return (
    <Drawer
      title={t('common:pivot')}
      ref={combinedRef as any}
      position="right"
      size={300}
    >
      <UniskaiPivotContent {...props} />
    </Drawer>
  );
});

UniskaiPivotTableDrawer.displayName = 'UniskaiPivotTableDrawer';

export default UniskaiPivotTableDrawer;
